var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 141,
    height: 53,
    viewBox: "0 0 141 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0.0405884H10.7219V13.778C10.7219 13.778 13.7374 10.7625 18.4283 10.7625C25.7996 10.7625 30.8255 15.7884 30.8255 24.1649V42.2581H20.1036V26.1752C20.1036 22.8246 18.0932 20.8143 15.4127 20.8143C12.7323 20.8143 10.7219 22.8246 10.7219 26.1752V42.2581H0V0.0405884Z",
    fill: "#1CE5BE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.347 11.4326H79.0534L80.7287 14.4481C80.7287 14.4481 84.4144 10.7625 89.7753 10.7625C96.8116 10.7625 103.848 17.7987 103.848 26.8453C103.848 35.8919 96.8116 42.9282 89.7753 42.9282C85.0845 42.9282 82.069 40.2477 82.069 40.2477V52.98H71.347V11.4326ZM93.1259 26.8453C93.1259 23.4947 90.4454 20.8142 87.4299 20.8142C84.4144 20.8142 81.7339 23.4947 81.7339 26.8453C81.7339 30.1959 84.4144 32.8764 87.4299 32.8764C90.4454 32.8764 93.1259 30.1959 93.1259 26.8453Z",
    fill: "#1CE5BE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.889 11.4326H115.596L117.271 14.4481C117.271 14.4481 120.957 10.7625 126.317 10.7625C133.354 10.7625 140.39 17.7987 140.39 26.8453C140.39 35.8919 133.354 42.9282 126.317 42.9282C121.627 42.9282 118.611 40.2477 118.611 40.2477V52.98H107.889V11.4326ZM129.668 26.8453C129.668 23.4947 126.988 20.8142 123.972 20.8142C120.957 20.8142 118.276 23.4947 118.276 26.8453C118.276 30.1959 120.957 32.8764 123.972 32.8764C126.988 32.8764 129.668 30.1959 129.668 26.8453Z",
    fill: "#1CE5BE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8877 20.8142C53.9032 20.8142 56.5837 23.4947 56.5837 26.8453H67.3056C67.3056 17.7987 60.2694 10.7625 50.8877 10.7625C41.506 10.7625 34.4698 17.7987 34.4698 26.8453H45.1917C45.1917 23.4947 47.8722 20.8142 50.8877 20.8142Z",
    fill: "#1CE5BE"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.79f2f2c93dfb75850e9f015998d1929b.svg";
export { ForwardRef as ReactComponent };